var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    d: "M12 18.857a6.857 6.857 0 1 0 0-13.714a6.857 6.857 0 0 0 0 13.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.038 13.714c-1.067.155-2.271 1.222-2.824 1.907a6.853 6.853 0 0 0 11.383.395l.013-.159c-.858-1.371-2.07-2.001-2.572-2.143c.716-1.855 1.676-6-.253-6s-2.46 2.859-2.533 4.5h-.428c-.073-1.641-.682-4.5-2.572-4.5c-1.967 0-.93 4.145-.214 6m3.176 3.215a.214.214 0 0 0-.429 0a.8.8 0 0 1-.128.471a.34.34 0 0 1-.3.172c-.373 0-.429-.172-.429-.215a.214.214 0 0 0-.428 0c0 .386.372.643.857.643c.3 0 .518-.154.66-.364c.128.188.334.364.625.364c.485 0 .858-.257.858-.643a.214.214 0 0 0-.429 0c0 .043-.056.215-.429.215c-.107 0-.21-.07-.3-.215a1 1 0 0 1-.128-.428",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgla);
export default __webpack_public_path__ + "static/media/agla.a7c278a474ec4d39a93d90d1f052c6f3.svg";
export { ForwardRef as ReactComponent };